import React, { memo, forwardRef } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import ExcelIcon from "../../../icons/ExcelIcon";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ExcelField');
var _ref2 = /*#__PURE__*/React.createElement(ExcelIcon, null);
const ExcelField = (_ref, ref) => {
  let {
    displayName
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: classes.headerIcon
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, _ref2), displayName);
};
export default /*#__PURE__*/memo(/*#__PURE__*/forwardRef(ExcelField));